import { useFlag } from 'utils/launchdarkly';

export const useIsLoyaltyEnabled = () => Boolean(useFlag('enable-loyalty'));
